module.exports = __webpack_public_path__ + "img/checkmark-s.233da30a.svg";